import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

type Props = {
  iconOnly?: boolean;
  iconName: IconName;
  label: string;
  isSelected?: boolean;
  onClick: () => void;
  dataId?: string;
};

export const ContentSwitcherButton = ({ iconOnly, iconName, label, isSelected, onClick, dataId }: Props) => {
  // Add specific data attribute for operatory button to enable robust DOM selection
  const isOperatoryButton = dataId === 'content-switcher-operatory-button';

  return (
    <NakedButton
      css={containerStyle(isSelected)}
      onClick={onClick}
      data-id={dataId}
      {...(isOperatoryButton && { 'data-operatory-button': true })}
    >
      <Icon name={iconName} size={16} css={{ flexShrink: 0 }} />
      {!iconOnly && (
        <Text size='medium' weight='bold'>
          {label}
        </Text>
      )}
    </NakedButton>
  );
};

const containerStyle = (isSelected?: boolean) =>
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.borderRadius.small,
    backgroundColor: isSelected ? theme.colors.white : 'transparent',
    ':hover': { backgroundColor: isSelected ? theme.colors.white : theme.colors.neutral20 },
    ...(isSelected && { boxShadow: theme.shadows.light }),
  });
